import PropTypes from 'prop-types';
import { createContext, useContext } from 'react';

const noop = () => {};

const defaultValue = {
  qeId: '',
  showInput: noop,
  hideInput: noop,
  toggleInput: noop,
  discountCode: '',
  formattedError: '',
  loading: false,
  formattedDiscountAmount: '',
  formattedDiscountCode: '',
  handleChange: noop,
  handleApply: noop,
  handleRemove: noop,
};

const DiscountCodeContext = createContext(defaultValue);

export const useDiscountCodeContext = () => useContext(DiscountCodeContext);

export const DiscountCodeContextProvider = ({ value, children }) => {
  return <DiscountCodeContext.Provider value={value}>{children}</DiscountCodeContext.Provider>;
};

DiscountCodeContextProvider.propTypes = {
  value: PropTypes.shape({
    qeId: PropTypes.string.isRequired,
    showInput: PropTypes.func.isRequired,
    hideInput: PropTypes.func.isRequired,
    toggleInput: PropTypes.func.isRequired,
    discountCode: PropTypes.string.isRequired,
    formattedError: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    formattedDiscountAmount: PropTypes.string.isRequired,
    formattedDiscountCode: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleApply: PropTypes.func.isRequired,
    handleRemove: PropTypes.func.isRequired,
  }).isRequired,
  children: PropTypes.node.isRequired,
};
